import {
  compose, find, get, getOr, map, replace, toNumber,
} from 'lodash/fp';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { specialCharacter } from '../../common/utils';

const XLSXExporter = {
  getFileName: ({ schoolName, groups, selectedGroup }) => {
    const [, groupId] = selectedGroup.value.match(/[^_]+/g);

    const groupName = compose(
      replace(/_+/g, '_'),
      replace(specialCharacter, ''),
      (groupType) => {
        switch (groupType) {
          case 'allGroup': {
            return '';
          }
          case 'gradeGroup': {
            return `${groupId}학년`;
          }
          case 'clazzGroup': {
            const { grade, class_name: clazzName } = find(clazzGroup => clazzGroup.id === toNumber(groupId), get('clazzGroups', groups.data));

            return `${grade}학년_${clazzName}반`;
          }
          case 'customGroup': {
            const { name } = find(customGroup => customGroup.id === toNumber(groupId), get('customGroups', groups.data));

            return name;
          }
          default: {
            return '';
          }
        }
      },
    )(selectedGroup.type);

    return replace(/_+/g, '_', schoolName ? `${schoolName}_${groupName}_주소록.xlsx` : `${groupName}_주소록.xlsx`);
  },
  exportContacts: ({ data, fileName }) => {
    const head = [
      '학년',
      '반',
      '번호',
      '학생 이름',
      '학생 휴대폰 번호',
      '학생 이메일',
      '대표 보호자 이름',
      '대표 보호자 관계',
      '대표 보호자 휴대폰 번호',
      '대표 보호자 이메일',
      '보조 보호자 이름',
      '보조 보호자 관계',
      '보조 보호자 휴대폰 번호',
      '보조 보호자 이메일',
    ];

    const body = map(c => [
      getOr('', 'grade', c.class_group),
      getOr('', 'class_name', c.class_group),
      c.number,
      c.name,
      c.mobile,
      c.email,
      getOr('', 'name', c.primary_guardian_contact),
      {
        father: '부',
        mother: '모',
        grand_father: '조부',
        grand_mother: '조모',
        etc: '기타',
      }[getOr('etc', 'relationship', c.primary_guardian_contact)],
      getOr('', 'mobile', c.primary_guardian_contact),
      getOr('', 'email', c.primary_guardian_contact),
      getOr('', 'name', c.secondary_guardian_contact),
      getOr('', 'relationship', c.secondary_guardian_contact),
      getOr('', 'mobile', c.secondary_guardian_contact),
      getOr('', 'email', c.secondary_guardian_contact),
    ], data);

    const sheet = [head, ...body];

    const worksheet = XLSX.utils.aoa_to_sheet(sheet);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, '연락처');

    const workbookOutput = XLSX.write(workbook, {
      type: 'array',
      bookType: 'xlsx',
    });

    saveAs(
      new Blob([workbookOutput], { type: 'application/octet-stream' }),
      fileName,
    );
  },
};

export default XLSXExporter;
